import { FormattedMessage } from 'react-intl';
import { matchPath, useLocation } from 'react-router';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { OnboardingHighlightWrapper } from '@sorare/core/src/components/onboarding/OnboardingHighlightWrapper';
import {
  MLB_MARKET_COMMON_MARKET_ADD_CARD,
  MLB_MARKET_COMMON_MARKET_DROP_CARD,
} from '@sorare/core/src/constants/__generated__/routes';
import { commonMarketplace, glossary } from '@sorare/core/src/lib/glossary';

import {
  buildMarketTabRoute,
  useNavigableMarketTabParams,
} from 'hooks/useNavigableMarketTabParams';

import { CommonMarketOnboarding } from '../CommonMarketOnboarding';
import { CommonMarketStatus } from '../CommonMarketStatus';

const Root = styled(FullWidthContainer)`
  padding-top: var(--unit);
  padding-bottom: var(--unit);
  background-color: var(--c-nd-50);
`;

const Row = styled(Horizontal)`
  justify-content: space-between;
`;

const ButtonWrap = styled(Horizontal)`
  padding: var(--half-unit);
  border-radius: var(--unit);
  background-color: var(--c-nd-200);
`;

export const CommonMarketHeader = () => {
  const location = useLocation();
  const { filterQuery } = useNavigableMarketTabParams();

  const addingCard = matchPath(
    MLB_MARKET_COMMON_MARKET_ADD_CARD,
    location.pathname
  );
  const droppingCard = matchPath(
    MLB_MARKET_COMMON_MARKET_DROP_CARD,
    location.pathname
  );

  return (
    <FullWidthContainer.NoPadding>
      <CommonMarketOnboarding />
      <OnboardingHighlightWrapper highlightName="CommonMarketHeader">
        <Root>
          <Row>
            <CommonMarketStatus />
            <ButtonWrap>
              <Button
                size="small"
                to={buildMarketTabRoute(
                  MLB_MARKET_COMMON_MARKET_ADD_CARD,
                  filterQuery
                )}
                color={addingCard ? 'secondary' : 'transparent'}
              >
                <FormattedMessage {...glossary.add} />
              </Button>
              <Button
                size="small"
                to={buildMarketTabRoute(
                  MLB_MARKET_COMMON_MARKET_DROP_CARD,
                  filterQuery
                )}
                color={droppingCard ? 'secondary' : 'transparent'}
              >
                <FormattedMessage {...commonMarketplace.drop} />
              </Button>
            </ButtonWrap>
          </Row>
        </Root>
      </OnboardingHighlightWrapper>
    </FullWidthContainer.NoPadding>
  );
};
